import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { FormRequestActions } from "../actions/formRequestActions";
import { ServerActions } from "../actions/serverActions";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { ContentBox } from "./admin/ContentBox";
import "../css/adminScreen.css";

function getInitialState() {
  return {
    showModal: false,
    isLoading: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortDirection: SortDirection.ASC,
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
    previousSub: "",
    selectedDescription: "",
    previousTab: "true",
    data: restrictionRequestStore.getFormPatterns(),
    filteredData: [],
    disableApply: true,
    selectedIndex: -1,
  };
}

function getStateFromStores() {
  return restrictionRequestStore.getFormPatterns();
}

export const FormCPatternModal = createReactClass({
  componentDidMount: function () {
    FormRequestActions.requestPatternList();
    restrictionRequestStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    restrictionRequestStore.unsubscribe(this._onChange);
  },

  getInitialState() {
    return getInitialState();
  },

  _onChange() {
    this.setState({ data: getStateFromStores() });
  },

  close() {
    this.setState({ showModal: false, selected: "", selectedIndex: -1 });
  },
  apply() {
    this.props.setText(this.state.selectedDescription);
    this.setState({ showModal: false, selectedIndex: -1 });
  },

  cancel() {
    this.setState({ showModal: false, selected: "", selectedIndex: -1 });
  },

  open() {
    var st = this.getInitialState();
    st.showModal = true;
    this.setState(st);
  },
  _rowClassName({ index }) {
    var selected = this.state.selectedIndex;
    if (index < 0 || index == selected) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },
  _noRowsRenderer() {
    var noRow;
    if (this.state.loading) {
      noRow = "Loading ...";
    } else {
      noRow = "No rows found";
    }
    return <div className="issuedNoRows">{noRow}</div>;
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },
  _sort({ sortBy, sortDirection }) {
    window.searchSortActive = true;
    this.setState({ selectedIndex: -1 });
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    };
    var rows = this.state.data.sort(comparer);
    this.setState({ filteredData: rows });
    this.setState({ sortBy, sortDirection });
  },
  _onRowClick: function (data) {
    var patternDescription = data.rowData.restrictionPatternLines;
    //var selectedDescription = this.state.selectedDescription;
    // selectedDescription.push(patternDescription)
    this.setState({
      selectedIndex: data.index,
      selectedDescription: patternDescription,
    });
  },
  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.data;
    this.setState({ selectedIndex: -1 });
    dataSet = dataSet.filter(function (item) {
      if (
        (item.restrictionPatternDescription + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.id + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  },
  formatValue({ dataKey, rowData }) {
    if (dataKey === "restrictionPatternDescription") {
      return renderDescriptionWithPopover(
        rowData.restrictionPatternDescription,
        rowData.restrictionPatternLines
      );
    } else if (dataKey === "id") {
      return renderNumberWithPopover(
        rowData.id,
        rowData.restrictionPatternLines
      );
    }
  },
  openPatternMaintenance: function () {
    this.close();
    ServerActions.openPatternMaintenance();
  },
  render: function () {
    const { rowHeight, headerHeight, overscanRowCount, sortBy, sortDirection } =
      this.state;

    let list =
      this.state.filteredData.length > 0
        ? this.state.filteredData
        : this.state.data;

    var searchBox = (
      <span style={{ float: "right" }}>
        <input
          type="text"
          className="searchId"
          placeholder="Search: "
          onChange={(event) =>
            this._filterRecordsOfTheTable(event.target.value)
          }
        />
      </span>
    );
    return (
      <span>
        <Button id="pattern" bsStyle="primary" onClick={this.open}>
          Pattern
        </Button>
        <Modal
          bsSize="large"
          dialogClassName="restrictionModal"
          onHide={this.close}
          show={this.state.showModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span>
                <b>Pattern Selection</b>{" "}
              </span>
              <span>{searchBox}</span>
            </Modal.Title>
          </Modal.Header>
          <div>
            <ContentBox>
              <div style={{ height: "30vh" }}>
                <AutoSizer>
                  {({ height, width }) => (
                    <Table
                      ref="Table"
                      disableHeader={false}
                      width={width}
                      height={height}
                      headerHeight={headerHeight}
                      rowHeight={rowHeight}
                      overscanRowCount={overscanRowCount}
                      rowCount={list.length}
                      rowClassName={this._rowClassName}
                      sort={this._sort}
                      sortBy={sortBy}
                      sortDirection={sortDirection}
                      noRowsRenderer={this._noRowsRenderer}
                      onRowClick={this._onRowClick}
                      rowGetter={({ index }) => list[index]}
                    >
                      <Column
                        width={width * 0.15}
                        label="Pattern#"
                        dataKey="id"
                        cellRenderer={this.formatValue}
                      />
                      <Column
                        width={width * 0.85}
                        label="Pattern Description"
                        dataKey="restrictionPatternDescription"
                        cellRenderer={this.formatValue}
                      />
                    </Table>
                  )}
                </AutoSizer>
              </div>
            </ContentBox>
          </div>
          <div className="modal-footer">
            <div className="row">
              <div className="col-md-2">
                <Button
                  id="patternsMaintenance"
                  bsStyle="primary"
                  onClick={this.openPatternMaintenance}
                >
                  Pattern Maintenance
                </Button>
              </div>
              <div className="col-md-10 pull-right">
                <Button id="patternCancel" onClick={this.cancel}>
                  Cancel
                </Button>
                <Button
                  id="pattenApply"
                  bsStyle="primary"
                  disabled={this.state.selectedIndex === -1}
                  onClick={this.apply}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </span>
    );
  },
});

function sortFunction(c1, c2) {
  if (c1.id < c2.id) {
    return -1;
  }
  if (c1.id > c2.id) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

function sortAndReturnPatternTexts(patternTexts) {
  var sortedPattern = patternTexts.sort(function (c1, c2) {
    return sortFunction(c1, c2);
  });

  let text = sortedPattern.map(function (patt) {
    return patt.lineText;
  });
  return text;
}

function renderDescriptionWithPopover(pattDesc, pattLineTexts) {
  if (pattDesc.length > 1) {
    var popOverBody = sortAndReturnPatternTexts(pattLineTexts);
    if (popOverBody.length > 20) {
      popOverBody = popOverBody.slice(0, 20);
    }

    const popover = (
      <Popover id="popover-basic">
        <table>
          <tbody>
            {popOverBody.map((val, i) => (
              <tr key={i}>
                <td id="patternPopOverText">{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Popover>
    );

    return (
      <OverlayTrigger placement="right" overlay={popover}>
        <span>{pattDesc}</span>
      </OverlayTrigger>
    );
  }
}

function renderNumberWithPopover(number, pattLineTexts) {
  var popOverBody = sortAndReturnPatternTexts(pattLineTexts);
  if (popOverBody.length > 20) {
    popOverBody = popOverBody.slice(0, 20);
  }
  const popover = (
    <Popover id="popover-basic">
      <table>
        <tbody>
          {popOverBody.map((val, i) => (
            <tr key={i}>
              <td id="patternPopOverText">{val}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Popover>
  );

  return (
    <OverlayTrigger placement="right" overlay={popover}>
      <span>{number}</span>
    </OverlayTrigger>
  );
}
